module.exports = __webpack_public_path__ + "img/Puente_Istobal_MWASH4_Alto_Blanco-default-back.14427e79.jpg";